import pendingReasonsService from "../../../services/pending-reasons/PendingReasonsService";
import i18n from "../../../i18n/index";


export default {
    data() {
        return {
            headers: [{
                text: i18n.t('headers.description'),
                sortable: false,
                value: "name"
            }, {
                text: i18n.t('headers.status'),
                sortable: false,
                value: "name"
            }],
            reasons: [],
            search: ''
        };
    },
    props: {},
    watch: {},
    mounted() {
        this.getReasons();
    },
    methods: {
        onRowClick(item) {
            this.$emit("row-click", item);
        },
        getReasons() {
            pendingReasonsService.getPendings().then(response => {
                this.reasons = response.data;
            });
        },
        customFilter(items, search, filter) {
            search = search.toString().toLowerCase()
            return items.filter(row => filter(row["name"], search));
        }
    }
};
